// export const formatDateYYYYMMDD = (date) => {
//   const d = new Date(date);

//   const year = d.getFullYear();
//   const month = String(d.getMonth() + 1).padStart(2, "0");
//   const day = String(d.getDate()).padStart(2, "0");

//   return `${year}/${month}/${day}`;
// };

export const formatDateYYYYMMDD = (date) => {
  if (!date) return "";

  // Handle DD-MM-YYYY or DD/MM/YYYY
  if (typeof date === "string" && /^[0-9]{2}[-/][0-9]{2}[-/][0-9]{4}$/.test(date)) {
    const [day, month, year] = date.split(/[-/]/);
    return `${year}-${month}-${day}`;
  }

  // Handle other valid date values
  const d = new Date(date);

  if (Number.isNaN(d.getTime())) return "";

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


export const formatDateToDisplay = (date) => {
  if (!date) return "";

  const [year, month, day] = date.split(/[/-]/);

  return `${day}/${month}/${year}`;
};
